export default function genererMarche() {
  return {
    code: null,
    libelle: null,
    societeId: null,
    dateSignature: null,
    dateDebut: null,
    dateFin: null,
    reconductibleTacitement: false,
    produits: [],
    commissions: [],
  };
}
